import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { PredefinedFilter } from 'src/app/models/predefined-filter';

@Component({
    selector: 'app-delete-predefined-filter',
    templateUrl: './delete-predefined-filter.component.html',
    styleUrls: ['./delete-predefined-filter.component.scss'],
    imports: [MatCardModule, MatButtonModule, MatDialogClose]
})
export class DeletePredefinedFilterComponent {
    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<DeletePredefinedFilterComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PredefinedFilter
    ) {}
}
